import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import ListPatientUsers from 'components/ListPatientUsers/ListPatientUsers';
//import ListPractices from 'components/ListPractices/testHooks';

const PatientUsers = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <ListPatientUsers />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("patientList")(PatientUsers);
